/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IStatusChangeSettingsModalControllerScope extends IBaseModalControllerScope {
        processConfigId: string;
        workflowBlock: models.IWorkflowBlock;
        isReadonly: boolean;
        dropDownOptions: Wars.Domain.Model.Dtos.Workflow.StatusDto[];
    }

    export class StatusChangeSettingsModalController extends BaseModalController {
        scope: IStatusChangeSettingsModalControllerScope;

        constructor(
            $scope: IStatusChangeSettingsModalControllerScope,
            workflowService: services.WorkflowService,
            processConfigId: string,
            workflowBlock: models.StatusChangeWorkflowBlock,
            isReadonly: boolean,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;

            workflowService.getStatuses(processConfigId).then((statusGroupsDto) => {
                this.scope.dropDownOptions = Enumerable.from(statusGroupsDto.statusGroups).where(i => i.id !== workflowBlock.statusChangeDto.currentStatusCodeId).toArray();
            });
        }
    }
}

warsApp.registerController('StatusChangeSettingsModalController', ['$scope', 'workflowService', 'processConfigId', 'workflowBlock', 'isReadonly', 'close']);